<template>
<div>
    <v-btn @click="dialog = !dialog" color="green" dark>Tạo phiếu chi</v-btn>
    <v-dialog
        max-width="80%"
        v-model="dialog"
    >
        <app-card>
            <h4>TẠO PHIẾU CHI</h4>
            <p class="fs-14 grey--text">Tạo phiếu chi mới</p>
            <v-form ref="form">
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex xs12 md3>
                            <v-select
                                :items="list_disbursement_type"
                                :disabled="loading.submit"
                                v-model="form.type"
                                :rules="[rules.required]"
                                prepend-icon="list"
                                label="Loại chi"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-select
                                label="Tòa nhà"
                                :disabled="loading.submit || form.type !== 'return_deposit'"
                                v-model="form.building"
                                :items="list_building"
                                prepend-icon="domain"
                                :rules="form.type === 'return_deposit' ? [rules.required] : []"
                                @change="form.room_id = ''"
                                required
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-select
                                label="Số phòng"
                                :disabled="loading.submit || form.type !== 'return_deposit'"
                                v-model="form.room_id"
                                :items="room_ids"
                                item-text="room_id"
                                item-value="rooms_id"
                                prepend-icon="meeting_room"
                                :rules="form.type === 'return_deposit' ? [rules.required] : []"
                                required
                                @change="findReceiptReturnDeposit()"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md3>
                            <wallet
                                label="Hình thức chi"
                                :input.sync="form.wallet_account_id"
                                :disabled="loading.submit"
                                required
                            ></wallet>
                        </v-flex>
                        <template>

                        </template>
                        <v-flex xs12 md3>
                            <v-text-field
                                label="Mã phiếu chi"
                                :disabled="(form.wallet_account_id && form.wallet_account_id !== 1) || loading.submit"
                                v-model="form.receipt_id"
                                prepend-icon="account_box"
                                :rules="[rules.required]"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-select
                                label="Người nhận"
                                :disabled="loading.submit"
                                v-model="form.receiver"
                                :items="[...bvs, { name: 'Khác'}]"
                                item-text="name"
                                item-value="name"
                                prepend-icon="person_pin"
                                required
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field
                                label="Số tiền chi"
                                :disabled="loading.submit"
                                v-model="form.amount"
                                prepend-icon="money"
                                :rules="[rules.required]"
                                v-currency
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-menu
                                :close-on-content-click="false"
                                v-model="menu_date_created"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                            >
                                <v-text-field
                                    slot="activator"
                                    v-model="form.date_created"
                                    label="Ngày tạo phiếu"
                                    :disabled="loading.submit"
                                    prepend-icon="event"
                                    readonly
                                    :rules="[rules.required]"
                                ></v-text-field>
                                <v-date-picker locale="vi-VI" v-model="form.date_created" @input="menu_date_created = false"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                label="Ghi chú"
                                v-model="form.note"
                                prepend-icon="event_note"
                                :disabled="loading.submit"
                            ></v-text-field>                            
                        </v-flex>
                        <v-flex xs12 v-if="alert.show">
                            <v-alert
                                :value="alert.show"
                                :type="alert.type"
                                outline
                            >
                                {{ alert.text }}
                            </v-alert>
                        </v-flex>
                        <v-flex xs12 v-if="form.type === 'return_deposit' && list_return_deposits.length">
                            <v-radio-group v-model="chosen_return_deposit" row>
                                <v-radio
                                    v-for="return_deposit in list_return_deposits"
                                    :key="return_deposit.check_out_id"
                                    :label="`Phiếu trả phòng: ${return_deposit.check_out_id} - Số tiền trả cọc: ${return_deposit.amount.toLocaleString('vi-VI')} đ`"
                                    :value="return_deposit"
                                    color="primary"
                                ></v-radio>
                            </v-radio-group>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        :loading="loading.submit"
                        :disabled="loading.submit || alert.show"
                        @click="submit"
                        color="green"
                        class="white--text"
                    >
                        Tạo Phiếu
                    </v-btn>
                </v-card-actions>
            </v-form>
        </app-card>
    </v-dialog>
</div>
</template>

<script>
import api from '../../api';
import { Wallet } from '../../components/Form'
import { list_building, list_disbursement_type } from '../../constants/db-config'
import { buildParamQuery } from '../../helpers/helpers';


export default {
    name: "dialog-tao-phieu-chi",
    components: {
        Wallet
    },
    data(){
        return {
            dialog: false,
            menu_date_created: false,
            loading: {
                submit: false
            },
            form: {
                receipt_id: '',
                date_created: '',
                amount: '',
                type: '',
                wallet_account_id: null,
                note: '',
                receiver: '',
                building: '',
                room_id: '',
                check_out_id: ''
            },
            list_building,
			rules: {
                required: value => !!value || 'Vui lòng điền thông tin này.',
            },
            list_disbursement_type,
            list_return_deposits: [],
            chosen_return_deposit: '',
            alert: {
                show: false,
                text: '',
                type: 'error'
            },
        }
    },
    computed: {
        rooms(){
            return this.$store.state.app.rooms
        },
        room_ids(){
            return this.rooms.filter( room => room.building === this.form.building)
        },
        bvs(){
            return this.$store.state.app.bvs
        }
    },
    watch: {
        'form.wallet_account_id': function (nv, ov){
            if (nv && nv !== 1){
                const unix_date = new Date().getTime()
                this.form.receipt_id = 'CK-' + unix_date.toString().substr(8, 12)
            }
        },
        'form.type'(nv){
            if (nv !== "return_deposit"){
                this.form.room_id = ''
                this.form.building = ''
                this.chosen_return_deposit = ''
            }
            this.alert.show = false
        },
        'form.room_id'(nv){
            this.chosen_return_deposit = ''
        },
        'chosen_return_deposit'(nv){
            if (nv){
                this.form.amount = nv.amount.toLocaleString('vi-VI') + " ₫"
                this.form.check_out_id = nv.check_out_id
                this.form.return_deposit_amount = nv.amount
            } else {
                this.form.check_out_id = ''
                this.form.amount = ''
            }
        }
    },
    methods: {
        clearInput: function (){
            this.$refs.form.reset()
            this.form.wallet_account_id = null;
            this.list_return_deposits = []
        },
        findReceiptReturnDeposit: async function (){
            this.alert.show = false
            // const params = {
			// 	building: this.chosen_building,
			// 	[this.search_type]: this.search,
			// 	lastDateOfMonth: last_date_of_month.toISOString(),
			// 	roomId: room_id,
			// 	isRefresh: true
            // }
            // const query = buildParamQuery(params)
            const params = {
                roomId: this.form.room_id,
                disbursementId: false
            }
            const query = buildParamQuery(params)
            const data = await api.getListReturnDeposit(query)

            if (data.status == 200){
                this.list_return_deposits = data.data.slice(0)
                if (!this.list_return_deposits.length){
                    this.alert.show = true
                    this.alert.text = `Không tìm thấy phiếu trả phòng của phòng ${this.form.room_id}`
                } else {
                    this.chosen_return_deposit = this.list_return_deposits[0]
                }
            } else {
                this.alert.show = true
                this.alert.text = "Lỗi không tìm thấy dữ liệu"
            }
        },
        submit: async function(){
            if (!this.$refs.form.validate()) {
                swal.fire('Lỗi', 'Vui lòng điền đầy đủ thông tin', 'error');
                return
            }
            const postData = {
                ...this.form,
                amount: this.$parseCurrency(this.form.amount,  "vi-VN", 'VND'),
                receiver: this.form.receiver !== "Khác" ? this.form.receiver : ""
            }

            this.loading.submit = true
            const data = await api.createDisbursementReceipt(postData);
            this.loading.submit = false
            if ( data.status === 200 ){
                this.dialog = false
                swal.fire('Thành công', data.data.message, 'success')
                this.$emit('reloadTable');
                this.clearInput()
            } else {
                swal.fire('Lỗi', data.message, 'error')
            }
        }
    }
}
</script>

<style>

</style>